import type { Job } from './GuideSendQueue';

/**
 * RAFAELS KLICK VERSCHIEBT DIE KARTE SOFORT — 21.09.2026, nach seinen Worten "zum
 * hundertsten Mal": *"das soll auf einen Klick im GUI sofort verschoben werden"*,
 * *"Er kann sie erst schliessen und dann bestaetigen."*
 *
 * GEMESSEN (Kanzler, 08:56:40Z): `POST /buehnen/:id/abschluss` antwortet SOFORT mit
 * `gespeichert: true`; der Abschluss selbst war 19,3 s spaeter fertig. Die Oberflaeche
 * hatte also alles, um die Karte wegzuraeumen, und wartete trotzdem auf die
 * Bestaetigung. Bei vierzehn Karten sind das Minuten reines Zusehen — und eine
 * Oberflaeche, die nach dem Klick stehenbleibt, sieht kaputt aus: man klickt noch
 * einmal. Dasselbe Nachtreten wie beim Arch-Gate mit seiner falschen Zeitangabe.
 *
 * ++ WARUM DAS NICHT DER FILTER VOM 15.09. IST ++
 * In `GuideHof` stand bis zum 15.09.2026 schon einmal ein Filter auf laufende
 * Abschluss-Auftraege, und er hat sieben Buehnen in KEINEN Raum gelegt (Messung
 * 19:13Z: 19 offene Buehnen, 12 in den Raumkoepfen). Er versteckte, sobald Rafaels
 * Eingabe unterwegs war — auch die, die haengenblieb. Drei Unterschiede hier:
 *
 *  1. NUR MIT SERVERQUITTUNG (`serverAccepted`, gesetzt erst bei `gespeichert: true`).
 *     Diese Marke gab es am 15.09. noch nicht; der alte Filter versteckte auf blosses
 *     "unterwegs".
 *  2. NIE EINEN BLOCKIERTEN: `blocked` bleibt sichtbar, mit Fehlertext an der Zeile.
 *  3. MIT GEDULDSGRENZE: danach kommt die Karte auf jeden Fall zurueck. "Haengt fuer
 *     immer" kann nicht mehr zu "verschwunden fuer immer" werden — das war der
 *     eigentliche Schaden von damals.
 *
 * Eigenes Modul, damit die Aussage pruefbar ist: aus `GuideHof.tsx` heraus laesst sie
 * sich nicht testen, weil der Import dort CSS mitzieht (dieselbe Begruendung wie bei
 * `guide-sendungstext.ts`).
 */
export const GEDULD_MS = 60_000;

/** Traegt dieser Auftrag einen vom Server quittierten Abschluss-Klick, der noch laeuft? */
export function istQuittierterAbschluss(j: Job | undefined): boolean {
  return j?.close === true && j.serverAccepted === true && j.state !== 'blocked';
}

/**
 * Fuehrt mit, seit wann eine Karte verschoben ist, und sagt, welche gerade verschoben
 * bleiben duerfen. `seit` wird in place gepflegt (der Aufrufer haelt sie in einem Ref).
 */
export function verschobeneAbschluesse(
  sendungen: ReadonlyMap<string, Job>,
  seit: Map<string, number>,
  jetzt: number,
  geduldMs = GEDULD_MS,
): (id: string) => boolean {
  for (const [id, j] of sendungen) {
    if (istQuittierterAbschluss(j)) { if (!seit.has(id)) seit.set(id, jetzt); }
    else seit.delete(id);
  }
  /* Ein Auftrag, den die Schlange abgeraeumt hat (`accept`), ist fertig — die Buehne
   * traegt dann ihren `abschluss` und faellt ohnehin aus den Raeumen. */
  for (const id of [...seit.keys()]) if (!sendungen.has(id)) seit.delete(id);
  return id => {
    const s = seit.get(id);
    return s !== undefined && jetzt - s < geduldMs;
  };
}
